export const replays = [require("url:../assets/data/replays/2022-01-01_07-40-16_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-01_21-40-18_DLH11C_3c66b6.csv"),
    require("url:../assets/data/replays/2022-01-02_13-00-34_AFR48NP_3950cf.csv"),
    require("url:../assets/data/replays/2022-01-02_18-58-44_AFR64ZR_39b16a.csv"),
    require("url:../assets/data/replays/2022-01-03_13-30-20_FJFMY_3a32dc.csv"),
    require("url:../assets/data/replays/2022-01-03_17-36-44_BGA221C_394a62.csv"),
    require("url:../assets/data/replays/2022-01-04_11-48-06_AIB01BE_3815ba.csv"),
    require("url:../assets/data/replays/2022-01-01_09-12-12_FHIAM_39a00c.csv"),
    require("url:../assets/data/replays/2022-01-01_14-32-07_TAR282_02a196.csv"),
    require("url:../assets/data/replays/2022-01-02_02-55-49_VOE912_3465d8.csv"),
    require("url:../assets/data/replays/2022-01-02_13-10-12_EJU382C_440065.csv"),
    require("url:../assets/data/replays/2022-01-03_00-19-32_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-03_13-34-33_VOE27PC_3461cf.csv"),
    require("url:../assets/data/replays/2022-01-03_21-59-34_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-04_12-06-48_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-01_10-50-19_FHIAR_39a011.csv"),
    require("url:../assets/data/replays/2022-01-01_15-09-29_FHZAM_39e40c.csv"),
    require("url:../assets/data/replays/2022-01-02_07-39-20_AFR59AA_392ae2.csv"),
    require("url:../assets/data/replays/2022-01-02_13-13-16_AFR7512_3950ce.csv"),
    require("url:../assets/data/replays/2022-01-03_01-40-07_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-04_06-39-38_EJU797D_440128.csv"),
    require("url:../assets/data/replays/2022-01-04_12-38-44_FHJAT_39a413.csv"),
    require("url:../assets/data/replays/2022-01-01_11-15-36_DLH62J_3c6745.csv"),
    require("url:../assets/data/replays/2022-01-01_15-46-52_FJDGY_3a2cbc.csv"),
    require("url:../assets/data/replays/2022-01-02_10-24-33_FHJAT_39a413.csv"),
    require("url:../assets/data/replays/2022-01-02_13-51-35_FJFMY_3a32dc.csv"),
    require("url:../assets/data/replays/2022-01-03_04-51-59_BCS1926_400518.csv"),
    require("url:../assets/data/replays/2022-01-03_14-43-53_AIB2IE_38131a.csv"),
    require("url:../assets/data/replays/2022-01-04_08-28-40_AFR71SY_3944f0.csv"),
    require("url:../assets/data/replays/2022-01-04_12-41-32_AFR24UA_3985a0.csv"),
    require("url:../assets/data/replays/2022-01-01_11-44-01_FHIAR_39a011.csv"),
    require("url:../assets/data/replays/2022-01-01_16-16-25_FHOLO_39b96e.csv"),
    require("url:../assets/data/replays/2022-01-02_11-17-48_EJU864T_44017c.csv"),
    require("url:../assets/data/replays/2022-01-02_15-01-27_FJFMY_3a32dc.csv"),
    require("url:../assets/data/replays/2022-01-03_11-11-05_SAMU31_39ac45.csv"),
    require("url:../assets/data/replays/2022-01-03_16-06-25_NAK67N_39b40a.csv"),
    require("url:../assets/data/replays/2022-01-04_09-03-19_AIB45XB_3c1230.csv"),
    require("url:../assets/data/replays/2022-01-01_12-24-51_DLH67X_3c66aa.csv"),
    require("url:../assets/data/replays/2022-01-01_16-20-36_DLH38M_3c66e5.csv"),
    require("url:../assets/data/replays/2022-01-02_11-22-26_FHJAT_39a413.csv"),
    require("url:../assets/data/replays/2022-01-02_15-34-58_FHZAM_39e40c.csv"),
    require("url:../assets/data/replays/2022-01-03_11-55-40_AOJ81R_440190.csv"),
    require("url:../assets/data/replays/2022-01-03_16-26-02_EZS71PU_4b1a22.csv"),
    require("url:../assets/data/replays/2022-01-04_10-14-29_NAK747_393642.csv"),
    require("url:../assets/data/replays/2022-01-04_13-01-47_FHTLI_39cd68.csv"),
    require("url:../assets/data/replays/2022-01-01_12-59-51_FHIAM_39a00c.csv"),
    require("url:../assets/data/replays/2022-01-01_18-29-00_AFR56LN_3946e9.csv"),
    require("url:../assets/data/replays/2022-01-02_11-23-09_DLH62J_3c6446.csv"),
    require("url:../assets/data/replays/2022-01-02_18-33-14_AFR56LN_394c13.csv"),
    require("url:../assets/data/replays/2022-01-03_12-28-07_FHRDG_39c466.csv"),
    require("url:../assets/data/replays/2022-01-03_16-31-22_AFR73KY_392aef.csv"),
];
